import { ECertifikatAktivita } from 'enums/isin/udaje/certifikatAktivita';

const certifikatAktivitaSelect = [
    {
        value: ECertifikatAktivita.K,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_K'
    },
    {
        value: ECertifikatAktivita.A,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_A'
    },
    {
        value: ECertifikatAktivita.DN,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_DN'
    },
    {
        value: ECertifikatAktivita.D,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_D'
    },
    {
        value: ECertifikatAktivita.KM,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_KOM'
    },
    {
        value: ECertifikatAktivita.M,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_M'
    },
    {
        value: ECertifikatAktivita.I,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_I'
    },
    {
        value: ECertifikatAktivita.UM,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_UM'
    },
    {
        value: ECertifikatAktivita.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_N_O'
    }
];

export default certifikatAktivitaSelect;
